<template>
    <div class="kt-portlet">
        <div class="kt-portlet__body" style="color: white; background-color: #3c5e79">
            <h6>{{ $t('dashboard.label.total_profit') }}</h6>
            <div class="text-center"><h2 class="fix-margin">{{ profit.total }} <span style="font-size: 1.5rem">{{' ' + $t('currency.rial')}}</span></h2></div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "total_profit",

        props: {
            profit: {
                default() {
                    return {}
                }
            },
        },
    }
</script>

<style scoped>

</style>